import { Box, Flex } from '@chakra-ui/react';

import { Markdown } from '~/components/markdown';
import { SanityImageType } from '~/features/page-template/models/image';

import { HeadingWithEmphasis } from './heading-with-emphasis';
import { SanityImage } from './sanity-image';

export type ImageContentBlockProps = {
  title: string;
  description: string;
  image?: SanityImageType | null;
  mobileImage?: SanityImageType | null;
  imageOrientation: 'left' | 'right';
  renderImageAboveOnMobile?: boolean;
};

export function ImageContentBlock({
  title,
  description,
  image,
  mobileImage,
  imageOrientation,
  renderImageAboveOnMobile,
}: ImageContentBlockProps) {
  return (
    <Flex
      alignItems='center'
      as='article'
      gap='24px'
      justifyContent='space-evenly'
      margin='0 auto'
      maxWidth={{ base: '100%', lg: 'content-max-width-lg' }}
      width='100%'
      flexDirection={{
        base: renderImageAboveOnMobile ? 'column-reverse' : 'column',
        lg: imageOrientation === 'right' ? 'row' : 'row-reverse',
      }}
    >
      <Box maxWidth={{ base: '100%', lg: '350px' }} width='100%'>
        <HeadingWithEmphasis
          text={title}
          emphasisProps={{
            color: 'blue.500',
            fontWeight: 500,
          }}
          headingProps={{
            as: 'h2',
            mb: '8px',
            size: 'h1',
          }}
        />

        <Markdown markdownText={description} />
      </Box>
      <Box display={{ base: mobileImage ? 'none' : 'block', lg: 'block' }}>
        {image && <SanityImage image={image} loading='lazy' />}
      </Box>
      {mobileImage && (
        <Box display={{ base: 'block', lg: 'none' }}>{image && <SanityImage image={mobileImage} loading='lazy' />}</Box>
      )}
    </Flex>
  );
}
